import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {ApiService, EnvironmentModel, ObservableData} from '@cas-hub/acabim-common-client';
import {AssetGroupResponse, AssetGroupRequest, AssetGroupsResponse} from '../_models/asset-group.model';

@Injectable({
    providedIn: 'root'
})
export class AssetGroupService extends ApiService {

    constructor(protected client: HttpClient, protected environment: EnvironmentModel) {
        super(client, environment);
    }

    protected controller = 'asset-group';

    /**
     * Add a new or update an existing asset group
     * @returns An asset group object
     */
    public upsertAssetGroup(name: string, description: string, id?: string) {
        const body: AssetGroupRequest = {
            name,
            description
        };
        const endpoint = id ? id : '';
        return this.client.post(this.url(endpoint), body, {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(item => item as AssetGroupResponse));
    }

    /**
     * Retrieve a single asset group
     * @returns Asset group details
     */
    public getAssetGroup(id: number): Observable<AssetGroupResponse> {
        return this.client.get(this.url(id.toString()), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(item => {
            console.dir(item);
            return item as AssetGroupResponse;
        }));
    }

    /**
     * Delete an asset group
     * @returns Accepted
     */
    public deleteAssetGroup(id: number): Observable<boolean> {
        return this.client.delete(this.url(id.toString()), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(item => {
            console.dir(item);
            return true;
        }));
    }

    /**
     * Retrieve all asset types
     * @returns An array of asset groups
     */
    public getAssetGroups(): Observable<ObservableData<AssetGroupResponse>>  {
        return this.client.get(this.url(''), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(tap(data => console.log(data)), map(data => ({
            totalRecords: (data as AssetGroupsResponse).count,
            data: (data as AssetGroupsResponse).data
        })));
    }


}
